<div class="essay-question__container">
  @if (question.minTextLength > 0) {
    <span class="fs__sm caption">Your answer must be a minimum of {{ question.minTextLength }} characters</span>
  }
  <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'" class="eiq-survey-textarea" [attr.aria-labelledby]="question.id">
    <textarea
      matInput
      surveyAutoFocus
      autocomplete="off"
      [errorStateMatcher]="immediateErrorMatcher"
      cdkTextareaAutosize
      cdkAutosizeMinRows="4"
      [formControl]="questionCtrl"
      [minlength]="question.minTextLength > 0 ? question.minTextLength : null"
      [maxlength]="question.maxTextLength > 0 ? question.maxTextLength : null"
    ></textarea>

    @if (loading$()) {
      <div matSuffix class="essay-question__container__suffix">
        <mat-spinner matSuffix diameter="20" color="secondary"></mat-spinner>
      </div>
    }

    @if (question.maxTextLength > 0) {
      <mat-hint class="max-length-hint">{{ questionCtrl.value | charactersLeft: question.maxTextLength }}</mat-hint>
    }

    <mat-error>
      @if (questionCtrl.errors; as error) {
        <span class="fs__md fw__500 essay-question__container__error">{{ error.message }}</span>
      }
    </mat-error>
  </mat-form-field>
</div>
